/* Explorador de categorías: imagen fija al pasar el cursor + tinte de fondo por categoría */
(function () {
  'use strict';

  var FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    var cursor = section.querySelector('[data-catx-cursor]');
    var links = Array.prototype.slice.call(section.querySelectorAll('[data-catx-link]'));
    var images = Array.prototype.slice.call(section.querySelectorAll('.catx__cursor-frame'));
    var baseAccent = section.style.getPropertyValue('--catx-accent');

    if (!cursor || links.length === 0) return;
    if (!FINE_POINTER.matches || REDUCED_MOTION.matches) return;

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        // la imagen se ancla al centro de la opción bajo el cursor,
        // pero sin desbordar los límites de la sección
        var sectionRect = section.getBoundingClientRect();
        var rect = link.getBoundingClientRect();
        var half = cursor.offsetWidth / 2;
        var x = rect.left - sectionRect.left + rect.width / 2;
        var y = rect.top - sectionRect.top + rect.height / 2;
        x = Math.min(Math.max(x, half), sectionRect.width - half);
        y = Math.min(Math.max(y, half), sectionRect.height - half);
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';

        var index = link.getAttribute('data-index');
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-index') === index);
        });
        cursor.classList.add('is-visible');
        var accent = link.getAttribute('data-accent');
        if (accent) section.style.setProperty('--catx-accent', accent);
      });
    });

    var list = section.querySelector('.catx__list');
    if (list) {
      list.addEventListener('mouseleave', function () {
        cursor.classList.remove('is-visible');
        if (baseAccent) section.style.setProperty('--catx-accent', baseAccent);
      });
    }

    section.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-visible');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-catx]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
